import { Link, useLocation } from 'react-router-dom';
import './topBar.css';

export const TopBar = ({ isAdmin, isRealAdmin, userList, impersonatedUser, onImpersonate, topOffset }) => {
  const location = useLocation();

  const nonAdminUsers = (userList ?? [])
    .filter(u => !u.isDeactivated && !u.is_admin)
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="topBar" style={topOffset ? { top: topOffset } : {}}>
      <Link to="/" className={`topBarLink${location.pathname === '/' ? ' topBarLinkActive' : ''}`}>
        Home
      </Link>
      <Link to="/care-report" className={`topBarLink${location.pathname === '/care-report' ? ' topBarLinkActive' : ''}`}>
        Care Report
      </Link>
      <Link to="/clients" className={`topBarLink${location.pathname === '/clients' ? ' topBarLinkActive' : ''}`}>
        Clients
      </Link>
      {isAdmin && (
        <>
          <Link to="/caretakers" className={`topBarLink${location.pathname === '/caretakers' ? ' topBarLinkActive' : ''}`}>
            Caretakers
          </Link>
          <Link to="/care-report-builder" className={`topBarLink${location.pathname === '/care-report-builder' ? ' topBarLinkActive' : ''}`}>
            Care Report Builder
          </Link>
          <Link to="/invoicing" className={`topBarLink${location.pathname === '/invoicing' ? ' topBarLinkActive' : ''}`}>
            Invoicing
          </Link>
          <Link to="/recurring-shifts" className={`topBarLink${location.pathname === '/recurring-shifts' ? ' topBarLinkActive' : ''}`}>
            Recurring Shifts
          </Link>
          <Link to="/payroll" className={`topBarLink${location.pathname === '/payroll' ? ' topBarLinkActive' : ''}`}>
            Payroll
          </Link>
          <Link to="/payroll-all" className={`topBarLink${location.pathname === '/payroll-all' ? ' topBarLinkActive' : ''}`}>
            Payroll All
          </Link>
        </>
      )}

      {isRealAdmin && !impersonatedUser && (
        <div className="topBarViewAs">
          <label className="topBarViewAsLabel">View as:</label>
          <select
            className="topBarViewAsSelect"
            value=""
            onChange={e => {
              const selected = nonAdminUsers.find(u => u.docID === e.target.value);
              if (selected) onImpersonate(selected);
            }}
          >
            <option value="">— select user —</option>
            {nonAdminUsers.map(u => (
              <option key={u.docID} value={u.docID}>{u.name}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};
